import { render, staticRenderFns } from "./GoalForm.vue?vue&type=template&id=e0a14070&"
import script from "./GoalForm.vue?vue&type=script&lang=js&"
export * from "./GoalForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports